<div class="chart-container">
  <canvas *ngIf="chartVisible" #chart baseChart [data]="chartData" [options]="options" [type]="'bar'" (chartClick)="onChartClick($event)"></canvas>
</div>
